import { InitialStateType, initialState } from "./context";
import { Actions } from "./types";
export enum stockEntryPayLoadTypes {
  ITEM = "ITEM",
  SUPPLIER = "SUPPLIER",
}
export const reducer = (state: InitialStateType, action: Actions) => {

  switch (action.type) {
    case stockEntryPayLoadTypes.ITEM:
      return {
        ...state,
        itm: action.payload.itm,
      };
    case stockEntryPayLoadTypes.SUPPLIER:
      return {
        ...state,
        supplier: action.payload.supplier,
      };

    default:
      return state;
  }
};
